import { createBrowserClient } from "@supabase/ssr";

export function createClient() {
  return createBrowserClient(
    "https://zzqvihchlrkicwllxklr.supabase.co"!,
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp6cXZpaGNobHJraWN3bGx4a2xyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTQwMzcyMjgsImV4cCI6MjAyOTYxMzIyOH0.Dn5ToT05Xu2bVJde22fE7TJsikpdNbkK-sfWABfW3-U"!
  );
}
